import Link from "next/link";
import Image from "next/image";
import CalendarIcon from "~/app/_components/icon/calendar";
import EnquiryIcon from "~/app/_components/icon/enquiry";
import PhoneCircleIcon from "~/app/_components/icon/phone";
import EmailIcon from "~/app/_components/icon/email";
import {
  INCLUSO_LINKEDIN,
  INCLUSO_FACEBOOK,
  INCLUSO_INSTAGRAM,
  INCLUSO_EMAIL,
  INCLUSO_PHONE,
} from "./value";
import TextLink from "~/app/_components/common/textLink";
import { ContactButton } from "~/app/_components/pageSpecific/contact/contactButton";
import { ElementType } from "react";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

export const SOCIAL_LIST = [
  {
    name: "Facebook",
    href: INCLUSO_FACEBOOK,
    icon: "/icons/Social Icons/Facebook-Icon.svg",
    description: "Incluso Services",
  },
  {
    name: "Instagram",
    href: INCLUSO_INSTAGRAM,
    icon: "/icons/Social Icons/Instagram Icon.svg",
    description: "@incluso_services",
  },
  {
    name: "LinkedIn",
    href: INCLUSO_LINKEDIN,
    icon: "/icons/Social Icons/Linkedin icon.svg",
    description: "Incluso Services",
  },
];

export const SOCIAL_LINKS = () => {
  return (
    <>
      {SOCIAL_LIST.map((item) => (
        <li key={item.name}>
          <Link
            href={item.href}
            className="text-xs leading-3 text-gray-300 hover:text-white xs:text-sm"
            target="_blank"
          >
            {item.name}
          </Link>
        </li>
      ))}
    </>
  );
};

export const SOCIAL_ICONS = ({ onClick }: GroupLinksProps) => {
  return (
    <>
      {SOCIAL_LIST.map((item, i) => (
        <Link
          key={item.name + i}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClick}
        >
          <Image
            src={item.icon}
            alt="item-media-icon"
            width={30}
            height={30}
            className="w-6 2xl:w-8"
          />
        </Link>
      ))}
    </>
  );
};

export const ENQUIRIES_LIST = [
  {
    name: "Phone",
    href: `tel:${INCLUSO_PHONE}`,
    icon: PhoneCircleIcon,
    description: INCLUSO_PHONE,
  },
  {
    name: "Form",
    href: "/contact-us#form",
    icon: EnquiryIcon,
    description: "Get in touch >",
  },
  {
    name: "Email",
    href: `mailto:${INCLUSO_EMAIL}`,
    icon: EmailIcon,
    description: INCLUSO_EMAIL,
  },
  {
    name: "Book",
    href: "/contact-us#book",
    icon: CalendarIcon,
    description: "Book a discovery call",
  },
];

export type ContactItem = {
  name: string;
  href: string;
  icon: JSX.Element | any;
  description: string;
};

export type GroupLinksProps = {
  description?: boolean;
  borderColour?: string;
  items?: ContactItem[];
  title?: string;
  width?: string;
  newTab?: boolean;
  bgColor?: string;
  iconSize?: string;
  onClick?: any;
};

export const GROUP_LINKS = ({
  items,
  title,
  borderColour,
  width,
  newTab,
  bgColor,
  iconSize,
}: GroupLinksProps) => {
  // add contact button for scroll-to-section effect
  const contactBtn = (
    items?: ContactItem[],
    item?: ContactItem,
    name?: string,
    i?: number,
  ) => (
    <ContactButton
      link
      section={name === "Form" ? "form" : name === "Book" ? "book" : "book"}
      key={i}
      variant="textLink"
      className={`flex items-center gap-3 ${items && i !== items.length - 1 ? "mb-2" : ""}`}
    >
      <div>
        {item && (
          <item.icon stroke="stroke-orange" size={iconSize ?? "size-6"} />
        )}
      </div>
      {item && <p>{item.description}</p>}
    </ContactButton>
  );
  return (
    <div
      className={`h-full rounded-xl border-2 ${bgColor ?? "bg-black/40"} px-4 py-6 lg:h-auto ${width ?? "w-[14rem]"} ${borderColour ?? ""}`}
    >
      <p className="mb-2 font-bold">{title}</p>
      {/*  h-5/6 : match content height */}
      <div className="flex h-5/6 flex-col justify-around">
        {items?.map((item, i) =>
          item.name === "Form" ? (
            contactBtn(items, item, "Form", i)
          ) : item.name === "Book" ? (
            contactBtn(items, item, "Book", i)
          ) : (
            <TextLink
              key={i}
              href={item.href}
              newTab={newTab}
              className={`flex items-center gap-3 ${i !== items.length - 1 ? "mb-2" : ""}`}
            >
              {title === "Socials" ? (
                <Image
                  src={item.icon}
                  alt="contact-icon"
                  width={30}
                  height={30}
                  className={`${iconSize ?? "w-7.5"}`}
                />
              ) : (
                <div>
                  <item.icon
                    stroke="stroke-orange"
                    size={iconSize ?? "size-6"}
                  />
                </div>
              )}

              <p>{item.description}</p>
            </TextLink>
          ),
        )}
      </div>
    </div>
  );
};
